<template>
	<div class="table">
		<el-table
			border
			ref="multipleTable"
			id="exportTab"
			:data="tableData"
			:header-cell-style="{ 'text-align': 'center' }"
			height="60vh"
			:cell-style="{ 'text-align': 'center' }"
			tooltip-effect="dark"
			style="width: 100%"
			@selection-change="handleSelectionChange"
			v-loading="loading"
		>
			<!-- <el-table-column type="selection" width="55"> </el-table-column> -->
			<el-table-column prop="id" label="id" width="65px"> </el-table-column>
			<el-table-column
				prop="title"
				label="专题标题"
				min-width="200px"
				show-overflow-tooltip
			>
				<template slot-scope="scope">
					<span class="source_title_span">
						{{ scope.row.topic_name }}
					</span>
				</template>
			</el-table-column>

			<el-table-column prop="update_date" label="更新时间" width="180px">
			</el-table-column>
			<el-table-column label="状态" width="100px">
				<template slot-scope="scope">
					<span v-if="scope.row.status == 1">已发布</span>
					<span v-else>草稿</span>
				</template>
			</el-table-column>
			<el-table-column label="链接" width="140px">
				<template slot-scope="scope">
					<span class="pointer margin_left_10" @click="showPreView(scope.row)">
						预览
					</span>
					<span class="pointer margin_left_10" @click="copyUrl(scope.row)">
						复制
					</span>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="140px">
				<template slot-scope="scope">
					<span class="pointer margin_left_10" @click="toEditNew(scope.row)">
						修改
					</span>

					<span class="pointer margin_left_10" @click="toDelete(scope.row)">
						删除
					</span>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
import {
	disInformation,
	delInformation,
	topInformation,
	informationHome,
	addInformation,
	addTgPush,
} from "@/api/article";
import { addAliPush } from "@/api/user";
import clipboard from "clipboard";
import ChineseConv from "chinese-s2t";

export default {
	props: ["tableData", "from", "loading"],
	name: "",
	data() {
		return {
			value: true,
		};
	},
	methods: {
		toggleSelection(rows) {
			if (rows) {
				rows.forEach((row) => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		toEditNew(row) {
			this.$router.push({
				path: "/message/aitopicdetail",
				query: { id: row.id, type: "edit" },
			});
		},

		showPreView(row) {
			let url = "https://dev.metaera.asia/aitopic/" + row.id;

			window.open(url, "预览");
		},
		copyUrl(row) {
			let msg = "https://dev.metaera.asia/aitopic/" + row.id;

			clipboard.copy(msg);
			this.$message({ message: "复制成功", type: "success" });
		},
		toDelete(row) {
			this.$confirm("此操作将删除该条资讯, 是否继续?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					delInformation({ id: row.id }).then((res) => {
						if (res.code == 200) {
							this.$message({
								type: "success",
								message: "删除成功!",
							});
							this.$parent.$parent.getDataList();
						}
					});
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消删除",
					});
				});
		},
	},
};
</script>

<style scoped>
.source_type_span {
	text-transform: capitalize;
}

.source_top_span {
	display: inline-block;
	padding: 2px 5px;
	border-radius: 3px;
	text-align: center;
	color: #fff;
	background: #ff4d4f;
}
</style>
